import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { AccountGuard } from './account.guard';
import { AppConfigService } from './app-config.service';
import { AuthGuard } from './auth.guard';
import { ConfigurationService } from './configuration.service';
import { ContextMenuService } from './context-menu/context-menu.service';
import { DialogService } from './dialog/dialog.service';
import { EmailService } from './email.service';
import { FeedbackBarService } from './feedback-bar/feedback-bar.service';
import { HttpService } from './http.service';
import { IdlePreload } from './idle-preload';
import { JobService } from './job.service';
import { LoadingBarService } from './loading-bar/loading-bar.service';
import { LocaleGuard } from './locale/locale.guard';
import { LocaleService } from './locale/locale.service';
import { LocalizedModelService } from './locale/localized-model.service';
import { ManagerGuard } from './manager.guard';
import { UserService } from './user/user.service';

import { ContextMenuComponent } from './context-menu/context-menu.component';
import { ControlsModule } from './controls/controls.module';
import { DialogComponent } from './dialog/dialog.component';
import { FeedbackBarComponent } from './feedback-bar/feedback-bar.component';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import { LoadingBarComponent } from './loading-bar/loading-bar.component';
import { NavComponent } from './nav/nav.component';
import { PageComponent } from './page/page.component';
import { PanelComponent } from './panel/panel.component';
import { ProgressComponent } from './progress/progress.component';
import { TableBodyRowComponent } from './table/body';
import { TableBodyComponent } from './table/body/table-body.component';
import { ColumnComponent } from './table/column.component';
import { TableHeaderComponent } from './table/header/table-header.component';
import { TableComponent } from './table/table.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TooltipDirective } from './tooltip/tooltip.directive';

const exportedComponents = [
  FooterComponent,
  NavComponent,
  ContextMenuComponent,
  ColumnComponent,
  FeedbackBarComponent,
  LoaderComponent,
  LoadingBarComponent,
  PageComponent,
  PanelComponent,
  ProgressComponent,
  TableComponent,
  TooltipComponent,
  TooltipDirective,
  DialogComponent,
];

const exportedModules = [
  ControlsModule
];

export const xsrfCookieName = 'X-XSRF-TOKEN';
export const xsrfHeaderName = 'X-XSRF-TOKEN';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        ...exportedModules
    ],
    declarations: [
        ...exportedComponents,
        TableHeaderComponent,
        TableBodyComponent,
        TableBodyRowComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        ...exportedComponents,
        ...exportedModules
    ]
})
export class CoreModule {
  static forRoot(appConfig: AppConfigService): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        AccountGuard,
        AuthGuard,
        ConfigurationService,
        ContextMenuService,
        DialogService,
        { provide: AppConfigService, useValue: appConfig },
        HttpService,
        IdlePreload,
        JobService,
        LocaleGuard,
        EmailService,
        FeedbackBarService,
        LocaleService,
        LoadingBarService,
        LocalizedModelService,
        ManagerGuard,
        UserService,
      ]
    };
  }
}
